module.exports = __webpack_public_path__ + "img/T1A_rc_9.3251f1d0.png";